import { smsClient } from '../client';
import type { CreateSmsPayload, CreateSmsResponse } from '../types';
import { smsGet } from './http';

export async function sendSms(body: CreateSmsPayload): Promise<CreateSmsResponse> {
  const { data, error } = await smsClient.POST('/send-sms/', { body });
  if (error) throw error;
  if (!data) throw new Error('Пустой ответ API');
  return data;
}

/** OpenAPI omits path `{id}` — use validation_id in URL segment. */
export async function fetchSmsReceipt(validationId: string, messageId: string): Promise<unknown> {
  return smsGet<unknown>(`/send-sms/receipt/${encodeURIComponent(validationId)}`, {
    message_id: messageId,
  });
}
